import { AppModel, Mode } from "models";
import history from "../services/history";
import { initialProductsList } from "../store";
import { isEqual } from "./arrayHelpers";

export function parseQueryString(qs: string): {
  text?: string;
  mode?: string;
  tag?: string[];
} {
  const pairs = qs.replace("?", "").split("&");
  const result: Record<string, string | string[]> = {};

  pairs.reduce((acc, cur) => {
    const [key, val] = cur.split("=");
    const decode = decodeURIComponent(val || "");
    if (key === "tag") {
      const arr = acc[key];
      if (arr) {
        (acc[key] as string[]).push(decode);
      } else {
        acc[key] = [decode];
      }
    } else {
      if (key === "text" && decode.startsWith("#")) {
        const tags = acc.tag;
        const tag = decode.substring(1);
        acc.tag = tags ? [...(tags as string[]), tag] : [tag];
      } else {
        acc[key] = decode;
      }
    }
    return acc;
  }, result);
  const urlText = pairs.find((s) => s.startsWith("text="))?.split("=")[1];
  if (
    decodeURIComponent((result.text as string) || "") !==
    decodeURIComponent(urlText || "")
  ) {
    setSearchingParams(
      result.tag as string[],
      result.text as string,
      result.mode as Mode
    );
  }
  return result;
}

export function updateFilterParams(store: AppModel) {
  const url = new URL(document.location.toString());
  const filterTags = url.searchParams.getAll("tag").map((type) => type);
  if (filterTags.length === 1 && filterTags[0] === "empty") {
    store.filterTags = [];
  } else if (filterTags.length) {
    store.filterTags = filterTags;
  } else {
    store.filterTags = JSON.parse(JSON.stringify(initialProductsList));
  }
  store.filterText = url.searchParams.get("text") || "";
}

export function setSearchingParams(
  filterTags?: string[],
  text?: string,
  mode?: Mode,
  path?: string
) {
  const url = new URL(document.location.href.toString().replace("#", "%23"));
  url.searchParams.delete("text");
  url.searchParams.delete("mode");
  url.searchParams.delete("tag");
  if (filterTags) {
    if (!isEqual(initialProductsList, filterTags)) {
      if (!filterTags.length) {
        url.searchParams.append("tag", "empty");
      } else {
        const tags = filterTags.map((tag) => tag);
        tags.forEach((tag) => {
          url.searchParams.append("tag", tag);
        });
      }
    }
  }
  if (text !== undefined) {
    if (text) url.searchParams.append("text", text);
  }
  if (mode !== undefined) {
    if (mode) url.searchParams.append("mode", mode);
  }
  history.push((path || document.location.pathname) + url.search.replace("%23", "#"));
}

export function getCurrentMode(): Mode {
  const qs = parseQueryString(location.href.split("?")[1] || "");
  switch (qs.mode) {
    case "result": {
      return "result";
    }
    case "js": {
      return "jsCode";
    }
    case "html": {
      return "htmlCode";
    }
    case "mobile": {
      return "mobile";
    }
    case "wide": {
      return "wide";
    }
    default: {
      return "";
    }
  }
}

export function getFilterParams() {
  const qs = parseQueryString(document.location.href.split("?")[1] || "");
  return { ...qs };
}
